import { render, staticRenderFns } from "./header-right.vue?vue&type=template&id=20c70a25&scoped=true&"
import script from "./header-right.vue?vue&type=script&lang=js&"
export * from "./header-right.vue?vue&type=script&lang=js&"
import style0 from "./header-right.vue?vue&type=style&index=0&id=20c70a25&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c70a25",
  null
  
)

export default component.exports